/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import {DataReference} from "../shared/DataReference";
import {Competition} from "../models/Competition";
import {StorageReference} from "../shared/StorageReference";
import {Observable, Subject} from "rxjs";
import {CompetitionMetadata} from "../models/schedule/metadata/CompetitionMetadata";
import {FirebaseApp} from "angularfire2";
import {AngularFireDatabase} from "angularfire2/database";
import * as firebase from "firebase";
import * as moment from 'moment';
import {StageSpriteUtils} from "../shared/StageSpriteUtils";
import {Tour} from "../models/Tour";


@Injectable()
export class CompetitionService {

  constructor(private firebase: FirebaseApp,
              private af: AngularFireDatabase) {
  }

  getCompetitionById(compId: string) : Promise<Competition> {
    return new Promise((resolve, reject) => {
      this.firebase.database().ref(DataReference.getCompetitionRef(compId)).once(DataReference.Value, snapshot => {
        if (snapshot.exists()) {
          let competition = Competition.fromSnapshot(snapshot);
          resolve(competition);
        } else {
          console.warn(`Competition ${compId} does not exist`);
          reject('Competition does not exist');
        }
      }, err => {
        console.error(err);
        reject(err);
      });
    });
  }

  getCompLogo(compId: string) : Promise<string> {
    return new Promise((resolve, reject) => {
      let picRef = this.firebase.storage().ref(StorageReference.getStorageCompetionLogoRef(compId));

      picRef.getDownloadURL().then(url => {
        resolve(url);
      }).catch((err: any) => {
        switch (err.code) {
          case StorageReference.StorageError.NotFound:
            resolve(StorageReference.DefaultCompetitionLogo);
            break;
          default:
            // TODO: flesh out errors
            console.error(err);
            resolve(StorageReference.DefaultCompetitionLogo);
            break;
        }
      });
    });
  }

  watchMetadata(compId: string, tourId: string, language: string = 'en') : Observable<CompetitionMetadata> {
    let observable: Subject<CompetitionMetadata> = new Subject();

    this.firebase.database().ref(DataReference.getCompetitionMetadataRef(compId, tourId, language)).on(DataReference.Value, snapshot => {
      if (snapshot.exists()) {
        console.log('it exists');
        observable.next(CompetitionMetadata.fromSnapshot(snapshot));
      } else {
        console.warn('Competition metadata does not exist for: ' + DataReference.getCompetitionMetadataRef(compId, tourId, language));
      }
    });

    return observable.asObservable();
  }

  getMetadata(compId: string, tourId: string, language: string = 'en') : Promise<CompetitionMetadata> {
    return new Promise((resolve, reject) => {
      this.firebase.database().ref(DataReference.getCompetitionMetadataRef(compId, tourId, language)).once(DataReference.Value, snapshot => {
        if (snapshot.exists()) {
          console.log('it exists');
          resolve(CompetitionMetadata.fromSnapshot(snapshot));
        } else {
          reject('Competition metadata does not exist for: ' + DataReference.getCompetitionMetadataRef(compId, tourId, language));
        }
      });
    });
  }

  getAllCompetitions() : Observable<Competition[]> {
    return this.af.list(DataReference.getCompetitionsRef())
      .snapshotChanges()
      .map(Competition.fromAngularFireSnapshots);
  }

  getCurrentToursForCompetition(compId: string) : Promise<Tour[]> {
    return new Promise((resolve, reject) => {
      let currentDate = moment().subtract(1, 'days').unix();
      console.log(currentDate);
      firebase.database().ref(DataReference.getToursRef(compId)).orderByChild('end').startAt(currentDate * 1000).once(DataReference.Value, snapshot => {
        if (snapshot.exists()) {
          let tours = Tour.fromSnapshots(snapshot);
          for (let tour of tours) {
            tour.formattedStart = StageSpriteUtils.formatLongDate(moment(tour.startTimestamp).toISOString());
            tour.formattedEnd = StageSpriteUtils.formatLongDate(moment(tour.endTimestamp).toISOString());
            // console.log(tour);
          }
          resolve(tours);
        } else {
          console.warn('No tours found for competition: ' + compId);
          resolve([]);
        }
      }, err => {
        console.error(err);
        reject(err);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/competition-service.ts